export default "data:image/webp;base64,UklGRlIAAABXRUJQVlA4TEYAAAAvJ0AHADUoiiTFEQDCVhH24XJOvyuCbJvpHmZCu5yQgEw5Ian6TzRt09jJXcGdp+DBuOvQf7dgeSGZsEoK29Nv0u+nz9YH"